import { httpApi } from "@/services/http.api";
import store from "@/store";
import storage from "@/components/utils/storage";
import qs from "qs";

export default {
  fetchFiltersData: async (filters, dateRange) => {
    const params = { ...filters };
    if (dateRange) {
      params.start_date = dateRange.start_date;
      params.end_date = dateRange.end_date;
    }
    const response = await httpApi.get(`/filters`, { params });
    const filtersValues = {};
    for (const key in response.data) {
      filtersValues[key] = response.data[key]
        .filter((element) => element && element.length)
        .sort();
    }
    return filtersValues;
  },

  fetchByFilters: async (filters, dateRange, page = 1, pageSize = 100) => {
    const filtersCopy = { ...filters };

    if (filtersCopy.createdAt && Array.isArray(filtersCopy.createdAt)) {
      filtersCopy.createdAtFrom = filtersCopy.createdAt[0];
      filtersCopy.createdAtTo = filtersCopy.createdAt[1];
      delete filtersCopy.createdAt;
    }
    if (filtersCopy.videoStart && Array.isArray(filtersCopy.videoStart)) {
      filtersCopy.videoStartFrom = filtersCopy.videoStart[0];
      filtersCopy.videoStartTo = filtersCopy.videoStart[1];
      delete filtersCopy.videoStart;
    }

    const params = {};
    Object.entries(filtersCopy).forEach(([key, v]) => {
      if (Array.isArray(v)) {
        params[key] = v.length === 1 ? v[0] : v;
      } else {
        params[key] = v;
      }
    });
    if (dateRange) {
      params.start_date = dateRange.start_date;
      params.end_date = dateRange.end_date;
    }

    params.page = page;
    params.pageSize = pageSize;

    const response = await httpApi.get("/orders", {
      params,
      paramsSerializer: (p) =>
        qs.stringify(p, { arrayFormat: "repeat", encode: true }),
    });
    if (response.status === 204) {
      return { items: [], totalCount: 0 };
    }

    const group =
      typeof storage.loadGroup === "function"
        ? storage.loadGroup()
        : storage.loadGroup;
    const cfg = store.state.config;
    const visibleFields =
      (cfg.visibleFields[group] ?? cfg.visibleFields[""]) || [];

    const items = response.data.items
      .map((el) => {
        visibleFields.forEach((key) => {
          if (el[key] == null) {
            el[key] = "";
          }
        });
        if (!el.integrity) {
          el.integrity = "FULL";
        }
        if (el.expedition) {
          el.expedition = parseInt(el.expedition, 10);
        }

        if (el.start_date) el.start_date = new Date(el.start_date);
        if (el.end_date) el.end_date = new Date(el.end_date);

        if (el.client) el.client = el.client.split("//");
        if (el.order) el.order = el.order.split("//");

        return el;
      })
      .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));

    return {
      items,
      totalCount: response.data.totalCount,
      totalPages: response.data.totalPages,
    };
  },

  fetchById: (orderNumber) => {
    return httpApi.get(`/orders/${orderNumber}`);
  },

  async fetchDataFilters(dateRange) {
    const params = {};
    if (dateRange) {
      params.start_date = dateRange.start_date;
      params.end_date = dateRange.end_date;
    }
    const response = await httpApi.get(`/filters`, { params });
    return response.data;
  },

  postOrder: async (params) => {
    const response = await httpApi.post(`/orders`, params);
    return response;
  },

  async getrecorders() {
    const response = await httpApi.get("/supervisor/recorders");
    return response.data;
  },

  fetchVideosByOrder: async (order) => {
    const response = await httpApi.post("/orders/videos", order);
    return response;
  },

  updateById: async (id, order) => {
    return httpApi.patch(`/orders/update/${id}`, order);
  },

  getOrderVideoUrl: (url) => {
    return `${process.env.VUE_APP_API_URL}/videos/url/${url}`;
  },

  async getTypes() {
    const response = await httpApi.get("/orders/types");
    return response.data || [];
  },

  deleteById: async (id) => {
    return httpApi.delete(`/orders/delete/${id}`);
  },

  deleteVideoById: async (uuid) => {
    return httpApi.delete(`/videos/delete/${uuid}`);
  },

  async generateVideo(id) {
    return httpApi.post(`/orders/${id}/generate`);
  },

  async fetchEventsOfOrder(orderId) {
    return httpApi.get("/events", { params: orderId });
  },
  fetchOrderSegments: async (id) => {
    const response = await httpApi.get(`/orders/${id}/segments`);
    return response.data;
  },
  fetchEventsByOrderId: async (orderId) => {
    const response = await httpApi.get(`/events/order/${orderId}`);
    return response.data;
  },
};
